/*!
 * Search Trigger
 * Dispatches events to the modal rendered at theme-body-bottom
 * (outside the navbar stacking context caused by backdrop-filter)
 */

<let/isOpen=false/>

<lifecycle onMount() {
  if (typeof window !== 'undefined') {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.isComposing || e.keyCode === 229) {
        return;
      }

      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        isOpen = !isOpen;
        window.dispatchEvent(new CustomEvent('search:toggle', { detail: { open: isOpen } }));
      }
      if (e.key === '/' && !isOpen && document.activeElement?.tagName !== 'INPUT') {
        e.preventDefault();
        isOpen = true;
        window.dispatchEvent(new CustomEvent('search:toggle', { detail: { open: true } }));
      }
      if (e.key === 'Escape' && isOpen) {
        e.preventDefault();
        isOpen = false;
        window.dispatchEvent(new CustomEvent('search:toggle', { detail: { open: false } }));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('search:closed', () => {
      isOpen = false;
    });

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('search:closed', () => { isOpen = false; });
    };
  }
}/>

<button
  class="search-trigger"
  aria-label="Search"
  onClick() {
    isOpen = true;
    window.dispatchEvent(new CustomEvent('search:toggle', { detail: { open: true } }));
  }>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
  <span class="search-label">Search</span>
  <kbd class="search-shortcut">
    <if=(typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform))>
      ⌘K
    </if>
    <else>
      Ctrl K
    </else>
  </kbd>
</button>

<style>
  .search-trigger {
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);
    padding: var(--space-sm) var(--space-md);
    border: 1px solid var(--border-default);
    background: var(--bg-alt);
    color: var(--text-2);
    font-size: var(--font-size-sm);
    border-radius: var(--radius-md, 8px);
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .search-trigger:hover {
    border-color: var(--color-primary-2, #3a5ccc);
    background: var(--bg-soft);
    color: var(--text-1);
  }

  .search-trigger:focus-visible {
    outline: 2px solid var(--color-primary-2, #3a5ccc);
    outline-offset: 2px;
  }

  .search-label {
    display: none;
  }

  @media (min-width: 768px) {
    .search-label {
      display: inline;
    }
  }

  .search-shortcut {
    padding: 2px 6px;
    font-size: 11px;
    font-family: var(--font-mono);
    background: var(--bg-default);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-sm, 4px);
    color: var(--text-3);
    display: none;
  }

  @media (min-width: 768px) {
    .search-shortcut {
      display: inline-block;
    }
  }
</style>
